import React from 'react';
import { X } from 'lucide-react';
import { ChatAvatar } from './ChatAvatar';
import { useAgentStore } from '../../../store/agentStore';
import { motion } from 'framer-motion';

interface ChatHeaderProps {
  onClose: () => void;
  showCloseButton?: boolean;
}

export function ChatHeader({ onClose, showCloseButton = true }: ChatHeaderProps) {
  const { currentAgent } = useAgentStore();
  
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="p-3 bg-gradient-to-r from-brand-600 to-brand-500 text-white flex items-center justify-between shadow-md"
    >
      <div className="flex items-center gap-3">
        <ChatAvatar />
        <div>
          <h3 className="font-semibold">{currentAgent.name}</h3>
          <div className="flex items-center gap-1">
            <span className="w-2 h-2 bg-green-400 rounded-full"></span>
            <p className="text-xs text-brand-100">{currentAgent.role}</p>
          </div>
        </div>
      </div>
      {showCloseButton && (
        <button 
          onClick={onClose} 
          className="text-white/80 hover:text-white p-1 rounded-full hover:bg-white/10 transition-colors"
        >
          <X size={20} />
        </button>
      )}
    </motion.div>
  );
}